<app-pan-card [isPageContainer]="true" pageContainerSize="xl" header="Review Management" [subheader]="subheader()">
  <app-pan-button leftActions color="primary" (click)="back()">Back</app-pan-button>
  <ag-grid-angular
    [loading]="isLoading()"
    [rowData]="entries()"
    [columnDefs]="columnDefs"
    [gridOptions]="tableDef"
    data-testid="review-activity-grid"
  ></ag-grid-angular>
</app-pan-card>
